import { useAnalytics } from 'hooks/useAnalytics';
import { sanitizeContentfulBlockId } from 'utils/contentful';
import Inserts from 'components/Shared/Inserts/Inserts';
import clsx from 'clsx';
import Button from './Button';
import styles from './Cta.module.scss';
import RichText from './RichText';
import type { InspectorPropsType } from 'hooks/useLivePreview';
import type { Document } from '@contentful/rich-text-types';
import type { IBlockCtaFields } from 'types/contentful/generated';

type Props = IBlockCtaFields & {
  textContent?: Document;
  inspectorProps?: InspectorPropsType;
  spacing?: boolean;
};

const Cta = ({
  blockId,
  title,
  textContent,
  ctaLink,
  ctaText,
  triggerLeadForm,
  inspectorProps,
  funnel,
  template,
  textAlignment,
  spacing,
  ...props
}: Props): JSX.Element => {
  const { trackEvent } = useAnalytics();

  if (template === 'Qunomedical') {
    return (
      <Inserts
        spacing={spacing}
        cta={{
          title,
          ctaText,
          ctaLink,
          triggerLeadForm,
          funnel,
          textContent,
          textAlignment,
          ...props,
        }}
      />
    );
  }

  return (
    <div id={sanitizeContentfulBlockId(blockId)} className={styles.container}>
      <hr />
      <div
        className={clsx(styles.wrapper)}
        style={{ textAlign: textAlignment || 'left' }}
      >
        <p className={styles.title} {...inspectorProps?.({ fieldId: 'title' })}>
          {title}
        </p>
        {textContent ? (
          <div
            className={styles.content}
            {...inspectorProps?.({ fieldId: 'textContent' })}
          >
            <RichText
              fields={textContent}
              config={{
                paragraph: styles.paragraph,
              }}
            />
          </div>
        ) : null}
        {triggerLeadForm ? (
          <div {...inspectorProps?.({ fieldId: 'ctaText' })}>
            <Button
              text={ctaText}
              theme="light"
              position={textAlignment || 'left'}
              triggerLeadForm
              funnel={funnel}
              parentHasEventTracking
              onClick={() => {
                trackEvent({
                  category: 'CTA',
                  action: 'CTA|Click',
                  label: `CTA|Block: CTA|${blockId}|${ctaText}`,
                });
              }}
              {...props}
            />
          </div>
        ) : (
          <Button
            text={ctaText}
            link={ctaLink}
            theme="light"
            position={textAlignment || 'left'}
            parentHasEventTracking
            onClick={() =>
              trackEvent({
                category: 'CTA',
                action: 'CTA|Click',
                label: `CTA|Block: CTA|${blockId}|${ctaText}`,
              })
            }
            {...props}
          />
        )}
      </div>
      <hr />
    </div>
  );
};

export default Cta;
